import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Identifier")
const _hoisted_4 = { class: "text-gray-500" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Number of files")
const _hoisted_6 = { class: "text-gray-500" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Owner")
const _hoisted_8 = { class: "text-gray-500" }
const _hoisted_9 = { class: "flex justify-between space-x-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Storage")
const _hoisted_11 = { class: "text-gray-500" }
const _hoisted_12 = { class: "flex justify-between space-x-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "truncate" }, "Total", -1)
const _hoisted_14 = { class: "flex-shrink-0" }
const _hoisted_15 = { class: "flex justify-between space-x-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "truncate" }, "Available", -1)
const _hoisted_17 = { class: "flex-shrink-0" }
const _hoisted_18 = { class: "flex justify-between space-x-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "truncate" }, "Used", -1)
const _hoisted_20 = { class: "flex-shrink-0" }

import {
  toRefs,
} from 'vue';
import { AccountPresenter, SHDWStorageAccount } from '@/models';
import { getAccountRoute, shortenPublicKey, toStorageSize } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: SHDWStorageAccount,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

// Storage info.
const { storage, storageAvailable } = account.value.decodedData;
const storageUsed = storage - storageAvailable;

const filesCount = account.value.totalFiles;
const name: string = account.value.decodedData.identifier;

const owner = account.value.decodedData.owner1;

return (_ctx: any,_cache: any) => {
  const _component_base_label = _resolveComponent("base-label")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_s_h_d_w_file_list_card = _resolveComponent("s-h-d-w-file-list-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(name)), 1),
        _createVNode(_component_base_label, { class: "mt-4" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(filesCount)), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "font-mono hover:text-gray-900",
              to: _unref(getAccountRoute)(_unref(owner))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(shortenPublicKey)(_unref(owner), 10)), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_11, [
          _createElementVNode("li", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(toStorageSize)(_unref(storage))), 1)
          ]),
          _createElementVNode("li", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(toStorageSize)(_unref(storageAvailable))), 1)
          ]),
          _createElementVNode("li", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(toStorageSize)(storageUsed)), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_s_h_d_w_file_list_card, { account: _unref(account) }, null, 8, ["account"])
  ]))
}
}

})